import moment from 'moment-timezone';

export default {
  currentDate: moment(new Date()).tz('Asia/Seoul').format('YYYYMMDD'),
  monitoringHistories: [],
  updatedMonitoringHistories: {},
};



// WEBPACK FOOTER //
// ./src/app/video-lecture/store/state.js